/**
 * Open/close plumbing for the picker "Insert" split buttons. The list stays open
 * until a placement is picked or the next click lands outside the dropdown.
 */
export class InsertDropdownController {
    protected isOpen: any;
    protected documentClickHandler: ((event: MouseEvent) => void) | null = null;

    /**
     * @param isOpen Knockout observable holding the open state, bound by the template.
     */
    constructor(isOpen: any) {
        this.isOpen = isOpen;
    }

    public toggle(): void {
        if (this.isOpen()) {
            this.close();
            return;
        }

        this.open();
    }

    public open(): void {
        this.isOpen(true);
        this.bindDocumentClick();
    }

    public close(): void {
        this.isOpen(false);
        this.unbindDocumentClick();
    }

    protected bindDocumentClick(): void {
        this.unbindDocumentClick();
        this.documentClickHandler = (event: MouseEvent) => {
            const target = event.target as Element | null;
            if (!target || !target.closest(".insert-dropdown")) {
                this.close();
            }
        };

        // Deferred so the click that opened the list doesn't immediately close it.
        window.setTimeout(() => {
            if (this.isOpen() && this.documentClickHandler) {
                document.addEventListener("click", this.documentClickHandler);
            }
        }, 0);
    }

    protected unbindDocumentClick(): void {
        if (this.documentClickHandler) {
            document.removeEventListener("click", this.documentClickHandler);
            this.documentClickHandler = null;
        }
    }
}



// WEBPACK FOOTER //
// ./js/utils/InsertDropdownController.ts